/* eslint-disable no-unused-expressions */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */

import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  resetSimActivationState,
  runSimActivationCheck,
} from '../../../../../../../actions/EpikBoxes';

export const useFetchSimStatus = (sims) => {
  const dispatch = useDispatch();
  const simActivationCheckState = useSelector(
    state => state.AppState.boxDetails.simActivationCheck,
  );
  const { connection: data, error } = simActivationCheckState;

  const fetchSimActivationStatus = useCallback(() => {
    dispatch(runSimActivationCheck(sims));
  }, [sims]);

  useEffect(() => {
    if (typeof data === 'object' && data?.message) toast.info(data.message);
    if (error) toast.error(error);
  }, [simActivationCheckState]);

  useEffect(
    () => () => {
      dispatch(resetSimActivationState());
    },
    [],
  );

  return { activationState: simActivationCheckState, fetchSimStatus: fetchSimActivationStatus };
};
